import React, { useEffect, useState } from "react";
import MultiClamp from "react-multi-clamp";

/** Nextjs */
import dynamic from "next/dynamic";

/** MUI */
import makeStyles from "@mui/styles/makeStyles";
import { Box, Paper, Typography, useMediaQuery } from "@mui/material";

/** Helpers */
import useHelper from "../../../_common/useHelper";
import { v4 as uuidv4 } from "uuid";
import { useTranslation } from "react-i18next";

/** redux */
import { useSelector } from "react-redux";
import { getShowGotoDB } from "@/src/_appStore/Common";

/** UI */
const Certificate = dynamic(() => import("../../_Commons/Certificate/Certificate"));
const HeaderInfoWidgetSubmenu = dynamic(() => import("./HeaderInfoWidgetSubmenu"));
const AppTooltip = dynamic(() => import("../../../_common/AppTooltip"));

const useStyles = makeStyles((theme) => ({
    WidgetBox: {
        ...theme.shape.boxedWrapper,
        height: 156, //'9vw',
        maxHeight: 156,
        minHeight: 156, //"8vw",

        // height: "100%",
        // margin: theme.spacing(0, 1),
        margin: theme.spacing(0, 0),
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-between",

        [theme.breakpoints.down("xl")]: {
            padding: theme.spacing(1),
            margin: 0,
            minHeight: "unset",
            maxHeight: "unset",
            height: "100%",
        },
        [theme.breakpoints.down("md")]: {
            margin: 0,
            minHeight: "unset",
            maxHeight: "unset",
        },
        [theme.breakpoints.down("sm")]: {
            height: "auto",
        },
    },
    Title: {
        fontSize: "1rem",
        fontWeight: 600,
        [theme.breakpoints.down("xl")]: {
            fontSize: "0.88888889rem",
            wordBreak: "break-word",
        },
        [theme.breakpoints.down("md")]: {
            fontSize: "0.77777778rem",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.88888889rem",
        },
    },
    Value: {
        fontSize: "1.25vw",
        fontWeight: 700,
        color: theme.palette.primary.main,
        [theme.breakpoints.down("xl")]: {
            fontSize: "1.33333334rem",
        },
        [theme.breakpoints.down("md")]: {},
        ["@media (max-width: 280px)"]: {
            fontSize: "1.77777778rem", //32,
        },
    },
    Description: {
        fontSize: "1rem",
        [theme.breakpoints.down("xl")]: {
            fontSize: "0.88888889rem",
        },
        [theme.breakpoints.down("md")]: {
            fontSize: "0.77777778rem",
        },
        [theme.breakpoints.down("sm")]: {
            fontSize: "0.88888889rem",
        },
    },
    valueWrapper: {
        display: "flex",
        flexGrow: 1,
        flexWrap: "wrap",
        flexDirection: "column",
        // justifyContent: "space-between",
        justifyContent: "flex-end",
    },
}));

const HeaderInfoWidget = (props) => {
    const classes = useStyles();
    const { intlNumberFormat } = useHelper();
    const { t, i18n } = useTranslation();
    const downXl = useMediaQuery((theme) => theme.breakpoints.down("xl"));

    const { title, value, description, precision, widget } = props || {
        title,
        value,
        description,
        precision: 2,
        widget: {},
    };
    const id = uuidv4();

    /** states */
    const [SHOW_TITLE_TIP, setSHOW_TITLE_TIP] = useState(false);
    const [OPEN_CERTIFICATE, setOPEN_CERTIFICATE] = useState(false);
    /** redux */
    const showGotoDB = useSelector(getShowGotoDB);

    /** effects */
    useEffect(() => {
        if (!id) return;
        setTimeout(() => {
            const clampAreaEl = document.querySelector(`#overf-title-${id}`);
            if (clampAreaEl) {
                setSHOW_TITLE_TIP(clampAreaEl.scrollHeight > clampAreaEl.clientHeight);
            }
        }, 666);
    }, [id]);

    /** handlers */
    const handleOnClickMeta = () => setOPEN_CERTIFICATE(true);

    const handleOnCloseCertificate = ({ show }) => setOPEN_CERTIFICATE(show);

    const handleOnGotoDD = () => {
        const href = widget?.indicator_id?.[0]
            ? `/${i18n.language}/baza-danych?id=${widget?.indicator_id?.join(",")}${
                  widget?.section_id !== null ? `&s=${widget.section_id}` : ""
              }`
            : undefined;

        if (href) window.location.href = href;
    };

    return (
        <>
            <Paper className={classes.WidgetBox}>
                <Box sx={{ display: "flex", alignItems: "flex-start", justifyContent: "space-between" }}>
                    {downXl ? (
                        <Typography className={classes.Title} component={"span"}>
                            <MultiClamp ellipsis="..." clamp={2} id={`overf-title-${id}`}>
                                {title?.replace(/(<([^>]+)>|\t|\n)/gi, "")}
                            </MultiClamp>
                        </Typography>
                    ) : (
                        <AppTooltip
                            title={SHOW_TITLE_TIP ? title?.replace(/(<([^>]+)>|\t|\n)/gi, "") : ""}
                            arrow
                            placement={"top-start"}
                            type={"dark"}
                        >
                            <span>
                                <Typography className={classes.Title} component={"span"}>
                                    <MultiClamp ellipsis="..." clamp={2} id={`overf-title-${id}`}>
                                        {title?.replace(/(<([^>]+)>|\t|\n)/gi, "")}
                                    </MultiClamp>
                                </Typography>
                            </span>
                        </AppTooltip>
                    )}

                    {!!showGotoDB && (
                        <HeaderInfoWidgetSubmenu
                            keyId={`${title}-${widget.id}`}
                            widget={widget}
                            onClickMeta={handleOnClickMeta}
                            onGotoDB={handleOnGotoDD}
                        />
                    )}
                </Box>
                <span className={classes.valueWrapper}>
                    {/* <Typography className={classes.Value}>{intlNumberFormat(value)}</Typography> */}
                    <span />
                    <Typography className={classes.Value}>{intlNumberFormat(value, precision)}</Typography>
                    <Typography className={classes.Description}>{description}</Typography>
                </span>
            </Paper>

            <Certificate
                indicatorId={widget?.indicator_id || 211}
                item={widget}
                show={OPEN_CERTIFICATE}
                onClose={(show) => handleOnCloseCertificate({ show })}
                hideIcon={true}
                color={"primary"}
            />
        </>
    );
};

export default HeaderInfoWidget;
